import axios from "axios";
import { toast } from "react-toastify";
import { API_URL } from "../utilities/config";

export async function filterLegalDiscoveries(page, pageSize, body, showError) {
  try {
    let data = await axios.post(
      `${API_URL}/filterLegaldiscoveryCases?page=${page}&page_size=${pageSize}`,
      body,
      {}
    );
    data = data.data;
    return data;
  } catch (error) {
    if (showError) {
      toast.error("Something went wrong. Please try again later");
    }
    return false;
  }
}

export async function getLegalDiscoveries(
  page,
  pageSize,
  body,
  showError = true
) {
  try {
    let data = await axios.post(
      `${API_URL}/fetchLegalDiscoveryCase?page=${page}&page_size=${pageSize}`,
      body,
      {}
    );
    data = data.data;
    return data;
  } catch (error) {
    if (showError) {
      toast.error("Something went wrong. Please try again later");
    }
    return false;
  }
}

export async function addQuickNotes(body) {
  try {
    let data = await axios.post(`${API_URL}/addQuickNote`, body, {});
    data = data.data;
    return data;
  } catch (error) {
    toast.error("Something went wrong. Please try again later");
    return false;
  }
}

export async function CaseOverview(page, pageSize, body, showError = true) {
  try {
    let data = await axios.post(
      `${API_URL}/caseOverview?page=${page}&page_size=${pageSize}`,
      body,
      {}
    );
    data = data.data;
    return data;
  } catch (error) {
    if (showError) {
      toast.error("Something went wrong. Please try again later");
    }
    return false;
  }
}

export async function DocumentOverviewAPI(
  page,
  pageSize,
  body,
  showError = true
) {
  try {
    let data = await axios.post(
      `${API_URL}/documentOverview?page=${page}&page_size=${pageSize}`,
      body,
      {}
    );
    data = data.data;
    return data;
  } catch (error) {
    if (showError) {
      toast.error("Something went wrong. Please try again later");
    }
    return false;
  }
}
